<template>
  <b-navbar type="is-black" wrapper-class="container" fixed-top>
    <template slot="brand">
      <b-navbar-item tag="router-link" :to="{ path: '/' }">
        <img src="/img/cfg_website_logo.png" width="150px" />
      </b-navbar-item>
    </template>
    <template slot="start">
      <!-- <b-navbar-item v-scroll-to="{ el: '#overview', duration: 500, offset: -49 }">About</b-navbar-item>
      <b-navbar-item v-scroll-to="{ el: '#testimonials', duration: 500, offset: -49 }">Testimonials</b-navbar-item> -->
      <b-navbar-item tag="router-link" to="/#overview">{{$t("menu.about")}}</b-navbar-item>
      <b-navbar-item tag="router-link" to="/#testimonials">{{$t("menu.testimonials")}}</b-navbar-item>
      <b-navbar-item tag="router-link" to="/#faq">{{$t("menu.faq")}}</b-navbar-item>
      <b-navbar-item tag="router-link" :to="{ path: '/pricing' }">{{$t("menu.pricing")}}</b-navbar-item>
      <b-navbar-item @click="showModal('changelog')">{{$t("menu.log")}}</b-navbar-item>
      <b-navbar-item @click="showModal('contact')">{{$t("menu.contact")}}</b-navbar-item>
    </template>

    <!-- <template slot="end" v-if="currentRouteName=='Home'">
      <b-navbar-item v-scroll-to="{ el: '#overview', duration: 500, offset: -49 }">About</b-navbar-item>
      <b-navbar-item v-scroll-to="{ el: '#testimonials', duration: 500, offset: -49 }">Testimonials</b-navbar-item>
      <b-navbar-item v-scroll-to="{ el: '#faq', duration: 500, offset: -49 }">FAQ</b-navbar-item>
      <b-navbar-item @click="showModal('changelog')">Changelog</b-navbar-item>
      <b-navbar-item @click="showModal('contact')">Contact</b-navbar-item>
      <b-navbar-item>
        <b-button type="is-primary" @click="openOnline()">Try</b-button>
        <b-button type="is-success" @click="showModal('install')">Install</b-button>
      </b-navbar-item>
    </template> -->
    <template slot="end">

          <b-navbar-dropdown :label="getLang(currentLang)" :arrowless="true">
                <b-navbar-item @click="langSwitch('ro')">
                    Ro
                </b-navbar-item>
                <b-navbar-item @click="langSwitch('ru')">
                    Ру
                </b-navbar-item>
                <b-navbar-item @click="langSwitch('en')">
                    En
                </b-navbar-item>
            </b-navbar-dropdown>
            <!-- <b-navbar-item tag="div">
              <b-button type="is-primary" @click="isMenu = !isMenu">{{$t("Categories")}}</b-button>
            </b-navbar-item>     -->
      <b-navbar-item tag="div">
        <div class="buttons">
          <b-button type="is-success" @click="showModal('install')">{{$t("menu.downloads")}}</b-button>
        </div>
      </b-navbar-item>
      <!-- <b-navbar-item>
        <b-icon icon="user"></b-icon>
      </b-navbar-item> -->

      <!-- <b-navbar-item v-if="!user.isLogged" @click="showModal('login')">Log In <b-icon class="ml-2" icon="arrow-right-to-bracket"></b-icon></b-navbar-item>
      <b-navbar-dropdown v-if="user.isLogged" label="Account">
        <b-navbar-item tag="router-link" to="/profile">
          Profile
        </b-navbar-item>
        <b-navbar-item @click="showModal('logout')">
          Log Out <b-icon class="ml-2" icon="arrow-right-from-bracket"></b-icon>
        </b-navbar-item>
      </b-navbar-dropdown> -->
    </template>
  </b-navbar>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "Navbar",
  methods: {
    showModal(modal) {
      console.log("showing modal");
      this.$store.commit("showModal", modal);
    },
    langSwitch(lang) {
      console.log(lang);
      this.currentLang = lang;
      this.$i18n.locale = lang;
      //this.$store.commit("setLang", lang);
      // this.$i18n.locale = lang;
    },
    getLang(lang) {
      let langNames = {
        ro: "Ro",
        ru: "Ру",
        en: "En",
      };
      return langNames[lang] || "En";
    },
  },
  computed: {
    ...mapState(["user"]),
    currentRouteName() {
        return this.$route.name;
    }
  },
};
</script>
<style>
.navbar-item img {
  max-height: unset !important;
}
</style>
